import React, { useMemo, useState } from 'react';
import { useData } from '../context/DataContext';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../components/Toast';
import ServiceTag from '../components/ServiceTag';

export default function Notas() {
  const { clientes, notas, addNota } = useData();
  const { user } = useAuth();
  const toast = useToast();

  const [q, setQ] = useState('');
  const [selId, setSelId] = useState(null);
  const [texto, setTexto] = useState('');
  const [guardando, setGuardando] = useState(false);

  const lista = useMemo(() => {
    let l = [...clientes].reverse();
    if (q.trim()) {
      const s = q.toLowerCase();
      l = l.filter(c => (c.nombre || '').toLowerCase().includes(s) || (c.whatsapp || '').includes(s));
    }
    return l;
  }, [clientes, q]);

  const sel = clientes.find(c => c.id === selId) || null;
  const notasSel = notas.filter(n => n.clienteId === selId).sort((a, b) => b.fecha.localeCompare(a.fecha));

  const guardar = async () => {
    if (!sel || !texto.trim()) return;
    setGuardando(true);
    await addNota(sel.id, texto.trim(), user.nombre);
    setTexto('');
    setGuardando(false);
    toast.show('Nota guardada y enviada al Sheet');
  };

  return (
    <div>
      <h1 style={{ fontSize: 20, fontWeight: 800, marginBottom: 16 }}>Notas de servicio</h1>
      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(220px, 300px) 1fr', gap: 14, alignItems: 'start' }} className="notas-grid">
        {/* Lista de clientes */}
        <div className="card" style={{ padding: 10, maxHeight: '70vh', overflowY: 'auto' }}>
          <input type="text" placeholder="Buscar cliente…" value={q} onChange={e => setQ(e.target.value)} style={{ marginBottom: 8 }} />
          {lista.map(c => (
            <button key={c.id} onClick={() => setSelId(c.id)} style={{
              display: 'block', width: '100%', textAlign: 'left', padding: '9px 10px',
              border: 'none', borderRadius: 8, marginBottom: 2,
              background: selId === c.id ? '#eff6ff' : 'transparent',
              color: selId === c.id ? '#185fa5' : '#0f172a',
              fontWeight: selId === c.id ? 700 : 500, fontSize: 14
            }}>
              {c.nombre}
              <div style={{ fontSize: 12, color: '#94a3b8', fontWeight: 500 }}>{c.servicio || '—'}</div>
            </button>
          ))}
          {!lista.length && <div style={{ fontSize: 13, color: '#94a3b8', padding: 10 }}>Sin resultados.</div>}
        </div>

        {/* Notas del seleccionado */}
        <div className="card" style={{ padding: 16, minHeight: 300 }}>
          {!sel && <div style={{ color: '#94a3b8', fontSize: 14 }}>Selecciona un cliente para ver y agregar notas.</div>}
          {sel && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, flexWrap: 'wrap' }}>
                <div style={{ fontWeight: 800, fontSize: 16 }}>{sel.nombre}</div>
                <ServiceTag servicio={sel.servicio} />
                <span style={{ fontSize: 13, color: '#94a3b8' }}>{sel.whatsapp}</span>
              </div>

              <textarea
                rows={3} value={texto} onChange={e => setTexto(e.target.value)}
                placeholder="Escribe una nueva nota de servicio…"
              />
              <button className="btn-primary" style={{ marginTop: 10 }} onClick={guardar} disabled={guardando || !texto.trim()}>
                {guardando ? 'Guardando…' : 'Guardar nota'}
              </button>

              {sel.notaSheet && (
                <div style={{ marginTop: 18 }}>
                  <div style={{ fontWeight: 700, fontSize: 13, color: '#475569', marginBottom: 6 }}>Notas en el Sheet</div>
                  <div style={{ background: '#f8fafc', borderRadius: 8, padding: '10px 12px', fontSize: 13, whiteSpace: 'pre-wrap' }}>
                    {sel.notaSheet}
                  </div>
                </div>
              )}

              <div style={{ marginTop: 18 }}>
                <div style={{ fontWeight: 700, fontSize: 13, color: '#475569', marginBottom: 6 }}>Historial del sistema</div>
                {!notasSel.length && <div style={{ fontSize: 13, color: '#94a3b8' }}>Sin notas registradas.</div>}
                {notasSel.map(n => (
                  <div key={n.id} style={{ background: '#f8fafc', borderRadius: 8, padding: '8px 12px', marginBottom: 6, fontSize: 13 }}>
                    <div style={{ whiteSpace: 'pre-wrap' }}>{n.texto}</div>
                    <div style={{ color: '#94a3b8', fontSize: 12, marginTop: 4 }}>
                      {n.autor} · {new Date(n.fecha).toLocaleString('es-MX')}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
